import React, { useState, useEffect } from "react";
import RegisterStyle from "./RegisterStyle.module.css";

//import components
import { ButtonLogin } from "../components/UI/Button";
import { SignUpValidation } from "../helper/functions";
import { RegisterUser } from "../services/api";
//material
import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";
//toastify
import { toastify } from "../helper/toast";
//import react router dom
import { Link, useNavigate } from "react-router-dom";

const Register = () => {
  const Navigate = useNavigate();
  //states
  const [value, setValue] = useState({
    fullName: "",
    email: "",
    password: "",
    rePassword: "",
    phoneNumber: "",
    birthDate: "1378/11/5",
    nationalId: "",
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [data,setData]= useState({})
  // use effect
  useEffect(() => {
    setErrors(SignUpValidation(value));
  }, [value]);
  //submitHandler
  const submitHandler = async (event) => {
    event.preventDefault();
    setTouched({
      fullName:'true',
      email: "true",
      password: "true",
      rePassword:'true',
      phoneNumber:'true',
      nationalId:"true"

    });
    if (!Object.keys(errors).length) {
      console.log({
        fullName: value.fullName,
        email: value.email,
        password: value.password,
        phoneNumber: value.phoneNumber,
        birthDate: value.birthDate,
        nationalId: value.nationalId,
      });
    
       setData(await RegisterUser({
        fullName: value.fullName,
        email: value.email,
        password: value.password,
        phoneNumber: value.phoneNumber,
        birthDate: value.birthDate,
        nationalId: value.nationalId,
      })) 
      console.log(data);
      if (data) {
        Navigate("/Login");
        toastify("ثبت نام با موفقیت انجام شد", "success");
      }
    }
  };

  //onChangeHandler
  const onChangeHandler = (event) => {
    setValue({ ...value, [event.target.name]: event.target.value });
  };
  //onFocusHandler
  const onFocusHandler = (event) => {
    setTouched({ ...touched, [event.target.name]: true });
  };
  return (
    <div className={RegisterStyle.container}>
      <form onSubmit={submitHandler} className={RegisterStyle.form}>
        <h3>ثبت نام</h3>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          
        </div>
        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 3 },
          }}
          noValidate
          autoComplete="off"
        >
          <div style={{ display: "flex", flexWrap:"wrap" ,alignItems: "center",justifyContent: "center"}}>
              <div>
            <TextField
              sx={{ m: 1 }}
              error={touched.fullName && errors.fullName}
              onFocus={onFocusHandler}
              id="outlined-basic"
              label="fullName"
              name="fullName"
              type="fullName"
              value={value.fullName}
              onChange={onChangeHandler}
              variant="outlined"
            />
            <p className={RegisterStyle.p}>
              {touched.fullName && errors.fullName}
            </p>
            </div>
            <div>
            <TextField
              sx={{ m: 1 }}
              error={touched.email && errors.email}
              onFocus={onFocusHandler}
              id="outlined-basic"
              label="email"
              name="email"
              type="email"
              value={value.email}
              onChange={onChangeHandler}
              variant="outlined"
            />
            <p className={RegisterStyle.p}>{touched.email && errors.email}</p>
            </div>
            <div>
            <TextField
              sx={{ m: 1 }}
              error={touched.password && errors.password}
              variant="filled"
              onFocus={onFocusHandler}
              id="outlined-basic"
              label="password"
              name="password"
              type="password"
              value={value.password}
              onChange={onChangeHandler}
              variant="outlined"
              />
            <p className={RegisterStyle.p}>
              {touched.password && errors.password}
            </p>
            </div>
            <div>
            <TextField
              sx={{ m: 1 }}
              error={touched.rePassword && errors.rePassword}
              onFocus={onFocusHandler}
              id="outlined-basic"
              label="rePassword"
              name="rePassword"
              type="password"
              value={value.rePassword}
              onChange={onChangeHandler}
              variant="outlined"
            />
            <p className={RegisterStyle.p}>
              {touched.rePassword && errors.rePassword}
            </p>
            </div>
            <div>
            <TextField
              sx={{ m: 1 }}
              error={touched.phoneNumber && errors.phoneNumber}
              onFocus={onFocusHandler}
              id="outlined-basic"
              label="phoneNumber"
              name="phoneNumber"
              type="text"
              value={value.phoneNumber}
              onChange={onChangeHandler}
              variant="outlined"
            />{" "}
            <p className={RegisterStyle.p}>
              {touched.phoneNumber && errors.phoneNumber}
            </p>
            </div>
            <div>
            <TextField
              sx={{ m: 1 }}
              error={touched.nationalId && errors.nationalId}
              onFocus={onFocusHandler}
              id="outlined-basic"
              label="nationalId"
              name="nationalId"
              type="email"
              value={value.nationalId}
              onChange={onChangeHandler}
              variant="outlined"
            />
            <p className={RegisterStyle.p}>
              {touched.nationalId && errors.nationalId}
            </p>
            </div>
           
          </div> <ButtonLogin onClick={submitHandler}>ثبت نام</ButtonLogin>
          <div className={RegisterStyle.LinkS}>
            <Link to="/Login">آیا حساب کاربری دارید؟</Link>
          </div>
        </Box>
      </form>
    </div>
  );
};

export default Register;
